<template>
  <div class="manager_dashboard">
  <user-menu />
  <div class="wrapper">
   
    <div class="content-wrapper" style="padding-left: 165px;">
    <div class="container-wrapper center">
    <div><h3 class="d-inline heading">{{ userFullName }}</h3></div>
    <div class="heading-seperator"></div>
    <div><h3 class="d-inline heading">{{ formName }}</h3></div>
    <div class="heading-seperator" style="margin-top: 0px;"></div>
 
        <vue-form-generator :schema="formData" :model="model" :options="formOptions" ref="vfg"></vue-form-generator>

        <div class="submit-wrapper margin-bottom-15">
          <button type="submit" class="btn btn-info btn-md" @click="onSubmit">Submit</button>
        </div>
   
    </div>
    </div>
  </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import router from '../../router/index.js';
import { store } from '../../store/store';

Vue.use(VueFormGenerator)


export default {
  data: function () {
    return {
      model: {},
      formId: '',
      formData: {},
      formName: '',
      userFullName: '',      
      formOptions: {
         validateAfterLoad: false,
         validateAfterChanged: true
      }
    };
  },  
  methods: {
     onSubmit() {
       var validationPassed = this.$refs.vfg.validate();

       if(validationPassed) {
         if (this.$store.state.user_accountid) {
           var formInsertUrl = '/forms-manager/insert-values/'+this.formId+'/'+this.$store.state.user_accountid;
         } else {
          if (store.state.roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            formInsertUrl = '/forms-manager/insert-values/'+this.formId+'/0';
          }
         }
          
          axios(formInsertUrl,
            {
              method: 'POST',
              data: this.model, 
            },
          )
          .then(response => {
              this.flash({ message: response.data.successMsg, variant: 'success' });
              if((this.$store.state.page_url) && 
                  ((this.$store.state.page_url.indexOf('account-lookup') > -1) 
                  || (this.$store.state.page_url.indexOf('account-lookup-detail') > -1) 
                  || (this.$store.state.page_url.indexOf('enterprise-lookup') > -1) 
                  || (this.$store.state.page_url.indexOf('enterprise-lookup-detail') > -1))
              ) {
                  router.push(this.$store.state.page_url);
              } else {
                router.push('/myprofile');
              }
          })
          .catch(error => {
             console.log(error) 
          });
       }  
     },     
  },
  components: {
    UserMenu,
  },
  created: function() {
    this.formId = this.$route.params.formId;

    axios.get('/user_fullname', {

              })
              .then(response =>  {
                  this.userFullName = response.data;
              })
              .catch(function(error) {
                  console.log(error);
              });

    axios.get('/forms-manager/render/'+this.formId, {
      })
      .then(response =>  {
        this.formName = response.data.forms.form_name;
        this.formData = {'fields': response.data.fields};
        this.model = response.data.models;
      })
      .catch(function(err) {
        console.log("Come here"+ err);
      });
    
  }
}
</script>
<style>
.vue-form-generator label {
    display: inline-block;
    margin-bottom: 0.5rem;
    width: 15%;
    float: left;
    font-weight: bold;
    margin: 3px 0px 3px 0px;
    font-size: 11px;
}
.vue-form-generator .field-radios .radio-list label {
    width: auto;
    min-width: 15%;
    font-weight: normal;
    margin-right: 20px;
    font-size: 12px;
}
.vue-form-generator .dropList label {
    width: auto;
    font-weight: normal;
    float: none;
    font-size: 12px;
}
.vue-form-generator .field-wrap {
    display: inline;
    width: auto;
    float: left;
    min-width: 22%;
}
.vue-form-generator .form-group {
    background-color: #F5F5F5;
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 0;
    padding: 5px;
}
.vue-form-generator .required {
    color: #000;
}
.vue-form-generator input[type="text"] {
    height: 25px;
    width: 22%;
}
.submit-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}
.form-group.error .errors span {
  background-image: none !important;
}   
</style>


// WEBPACK FOOTER //
// src/components/manager/form_render.vue